import { LogoDefault } from './LogoDefault.js';

export const LogoCategories = (slug) => {
    let src;
    try {
        src = require(`../assets/images/categories/${slug}.webp`);
    } catch (e) {
        console.log(e);
        src = LogoDefault();
    }
    return src;
}